//@ts-nocheck
// WIP fix thousands of types

import { useState } from "react";

import Extended from "./Extended";
import Default from "./Default";

const CarSpecs = ({ content }) => {
  const { data } = content;
  const [val, setVal] = useState(0);
  const [highlightedColumn, setHighlightedColumn] = useState(null);

  const handleMouseEnter = (index) => {
    setHighlightedColumn(index);
  };

  const handleMouseLeave = () => {
    setHighlightedColumn(null);
  };
  switch (data.tableType) {
    case 1:
      return <Extended data={data.table} content={content} />;
    case 0:
      return <Default data={data} content={content} />;

    default:
      return <div>No Table Type provied</div>;
  }

  return <div>d</div>;
};

export default CarSpecs;
